export enum MessageEnum {
  neutral = 'neutral',
  info = 'info',
  help = 'help',
  warning = 'warning',
  confirm = 'confirm',
  error = 'error',
}

export enum MessageIcon {
  neutral = '',
  info = 'info',
  help = 'help',
  warning = 'warning',
  confirm = 'check_circle',
  error = 'error',
}

